import * as t from "io-ts";

export const LatLngCodec = t.intersection([
  t.type({
    lat: t.number,
    lon: t.number,
  }),
  t.partial({}),
]);

export type LatLng = t.TypeOf<typeof LatLngCodec>;
